module.exports = __webpack_public_path__ + "static/media/home.b71ba825.png";